import { gql } from '@apollo/client'

/**
 * Graphql Query - To get Chat user token
 */
export const GET_CHAT_USER_TOKEN = gql`
  query {
    chatUserToken: getChatUserToken {
      token
    }
  }
`

/**
 * This query returns constraint if a username exists else null
 * @param constraint is the value to check for set validation, so the value of username
 */
export const VALIDATE_USERNAME_UNIQUENESS = gql`
  query GetConstraint($constraint: String!) {
    getConstraint(input: { constraint: $constraint }) {
      id
    }
  }
`
